import { backendAxios } from "../Services/axios";
import iPrivacy from "../models/iPrivacy";

export default class PrivacyController {
  static async sendConsent(payload: {
    email?: string;
    target?: string;
    consent: boolean;
  }): Promise<iPrivacy> {
    const response = await backendAxios.post("/consent", {
      email: payload.email,
      target: payload.target,
      consent: payload.consent,
    });
    return response.data;
  }
}
